<!--<input
  type="text"
  class=" form-control mt-0 "
  placeholder=" YYYY-MM-DD"
  bsDatepicker
  #datePicker
  autocomplete="off"
  [daysDisabled]="daysDisabled"
  [(ngModel)]="startDate"
  [bsConfig]="config"
  [isOpen]="isopen"
  [bsValue]="startDate"
  (ngModelChange)="handleDateChange($event)"
  (onShown)="handleOpen($event)"
/>-->

<p-calendar
  [placeholder]="'YYYY-MM-DD'"
  [dateFormat]="'yy-mm-dd'"
  [firstDayOfWeek]="1"
  [inputStyleClass]="'form-control custom-placeholder'"
  [disabledDays]="daysDisabled"
  [maxDate]="maxDate"
  [minDate]="minDate"
  [(ngModel)]="startDate"
  [appendTo]="'body'"
  [readonlyInput]="readonlyInput"
  (onSelect)="handleDateChange($event)"
  (onInput)="handleDateChange($event)"
/>
